import React from 'react';
export function ProblemSection() {
  return <section className="mb-16" data-id="element-43">
      <p className="text-lg mb-6" data-id="element-44">I had spent years in therapy.</p>
      <p className="text-lg mb-6" data-id="element-45">
        And while therapy gave me insight, language, and understanding… it
        didn't change how my body felt.
      </p>
      <p className="text-lg mb-6" data-id="element-46">
        Even after "processing" so much mentally, my body still felt stuck in
        survival.
      </p>
      <p className="text-lg mb-6" data-id="element-47">
        I was tense all the time. Anxious out of nowhere. Exhausted from pushing
        so hard to heal — yet still feeling trapped in the same cycles.
      </p>
      <p className="text-lg mb-6" data-id="element-48">
        That's when I learned: you can't talk your way out of survival mode.
      </p>
      <div className="bg-gray-100 p-6 rounded-lg mb-8 border-l-4 border-teal-600" data-id="element-49">
        <p className="text-2xl text-center font-semibold text-gray-700" data-id="element-50">
          Because survival patterns live in the nervous system — especially in
          the body, not just in the mind.
        </p>
      </div>
      <p className="text-lg mb-6" data-id="element-51">
        And unless you address what's happening at the nervous system level, no
        amount of insight will fully release those patterns.
      </p>
      <div className="mb-8" data-id="element-52">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wLEv45hw9jnaQ2SNH4UkHc/17cef8e-2885-4324-66a2-30e65137f44_fibromyalgiaNervePainBrain-1067733668-770x553_jpg_%281%29.webp" alt="Diagram showing nervous system connections" className="w-full rounded-lg shadow-md" data-id="element-53" />
      </div>
      <p className="text-lg mb-6" data-id="element-54">Here's where it clicked for me:</p>
    </section>;
}